// extracted by mini-css-extract-plugin
module.exports = {"aboutBanner":"About_aboutBanner_167Uf"};